import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { appInsights } from './telemetryConfig';
import { TelemetryService } from './services/TelemetryService';
import AuthenticatedApp from './AuthenticatedApp';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  useEffect(() => {
    // Initialize Application Insights once
    if (appInsights) {
      try {
        appInsights.loadAppInsights();
        TelemetryService.trackPageView('App_Initialized');
        console.log("Application Insights initialized successfully.");
      } catch (error) {
        console.warn("Application Insights already initialized or failed to initialize:", error);
      }
    } else {
      console.log("Application Insights not available - no valid connection string provided");
    }
  }, []);

  return (
    <Router>
      <ErrorBoundary>
        <AuthenticatedApp />
      </ErrorBoundary>
    </Router>
  );
}

export default App;
